const getToken = async (_apiKey: string) => {
  let resp = await fetch(`/api/token?api=${encodeURIComponent(_apiKey || '')}`)
  let token = await resp.text()

  return token
}

export { getToken }
